/**
 * Strip a failed patient-search rejection down to something safe to log.
 *
 * A raw GraphQL rejection carries partial `data` alongside `errors` — patient names and birth
 * dates — which must never reach the logger. Keep the messages only.
 *
 * Lives outside `epics/` on purpose: `epics/index.js` registers EVERY export of an epic module
 * via `combineEpics(...Object.values({ ...pmsEpic }))`, so a helper exported from there is called
 * as an epic and crashes the app on load.
 */
export const scrubGraphqlError = err => {
  if (err?.errors) {
    return {
      message: 'createoradd patient search failed',
      errors: err.errors.map(({ message, errorType }) => ({ message, errorType }))
    }
  }

  // An ordinary JS error carries no patient data, and discarding its message left a classifier or
  // trackEvent bug near-undiagnosable in Datadog.
  return {
    message: err?.message || 'createoradd patient search failed',
    name: err?.name
  }
}
